import { ALLOWED_COMMUNITY_CATEGORIES } from '../../../constants/section-constants/community-constants';
import {
  deleteRequest,
  getRequest,
  postRequest,
  patchRequest
} from '../../Common/network-call';
import { loadFromLocalDB, setInLocalDB } from '../../../reducers/localStorage';
import { fetchDetailsByExhibitorId } from '../../exhibitors/actions';
import { shuffleComments } from '../../../util/util-common';
import {
  PORTAL_LOCALSTORAGE_ACCESS_KEY,
  SCRIPT_URI_ADDON,
  TABLE_URI_ADDON
} from '../../../constants/constant';
import { fetchDetailsBySponsorId } from '../../sponsors/actions';
import {
  FETCH_ORDERS,
  FIELDS,
  SCRIPTS,
  TABLES
} from '../../../constants/section-constants/eventify-constant';
import { showSuccess } from '../../Common/alertmessage';
import LocalStrings from '../../../assets/languages';

export const FETCH_COMMUNITYCATEGORY = 'FETCH_COMMUNITYCATEGORY';
export const SET_FORUM_DETAILS = 'SET_FORUM_DETAILS';
export const FETCH_FORUM_DETAILS = 'FETCH_FORUM_DETAILS';
export const SHOW_ONLY_COMMUNITY_DETAILS = 'SHOW_ONLY_COMMUNITY_DETAILS';
export const FETCH_POST_COMMENT = 'FETCH_POST_COMMENT';
export const SET_POST_COMMENT = 'SET_POST_COMMENT';
export const SHOW_POST_COMMENT_MODAL = 'SHOW_POST_COMMENT_MODAL';
export const SET_POST = 'SET_POST';
export const FETCH_POST_LIKE = 'FETCH_POST_LIKE';
export const CREATE_POST_MODAL = 'CREATE_POST_MODAL';
export const FETCH_NEW_MESSAGE = 'FETCH_NEW_MESSAGE';
export const FETCH_OLD_MESSAGE = 'FETCH_OLD_MESSAGE';
export const SELECTED_COMMUNITY_DETAILS = 'SELECTED_COMMUNITY_DETAILS';
export const UNREAD_COMMUNITY_MESSAGE_COUNT = 'UNREAD_COMMUNITY_MESSAGE_COUNT';

export const fetchCommunityCategory = (session, callback = null) => {
  const fetchFilter = encodeURI(`(eventid=${session.eventid})`);
  const fetchUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.communityCategory}?filter=${fetchFilter}&fields=${FIELDS.communityCategory.mediumInfo}&order=${FETCH_ORDERS.communityCategory}&userid=${session.userid}&caller=app`;

  return dispatch => {
    getRequest(
      fetchUrl,
      session,
      dispatch,
      res => {
        dispatch({ type: FETCH_COMMUNITYCATEGORY, payload: res });
        callback && callback({ success: 1, data: res, error: null });

        // --- Managing the local storage for unread count
        const previousData = loadFromLocalDB(
          PORTAL_LOCALSTORAGE_ACCESS_KEY.community
        );
        let unreadMessage = 0;
        if (previousData == undefined) {
          let payloadData = [];
          if (!_.isEmpty(res?.resource)) {
            _.map(res.resource, comm => {
              payloadData.push({
                id: comm.communitycategoryid,
                name: comm.categoryname,
                count: 0
              });

              unreadMessage += _.includes(
                ALLOWED_COMMUNITY_CATEGORIES.post,
                comm.type
              )
                ? comm?.postcount
                : comm.commentcount;
            });
          }
          setInLocalDB({
            key: PORTAL_LOCALSTORAGE_ACCESS_KEY.community,
            value: payloadData
          });
        } else {
          _.map(res.resource, comm => {
            let local_newMsgCount = _.includes(
              ALLOWED_COMMUNITY_CATEGORIES.post,
              comm.type
            )
              ? comm?.postcount
              : comm.commentcount;

            let local_prevPostCommentCount = _.find(
              previousData,
              commItem => commItem?.id == comm?.communitycategoryid
            );
            if (local_prevPostCommentCount) {
              local_newMsgCount =
                local_newMsgCount - local_prevPostCommentCount?.count;
            }
            unreadMessage += local_newMsgCount;
          });
        }
        dispatch({
          type: UNREAD_COMMUNITY_MESSAGE_COUNT,
          payload: unreadMessage
        });
      },
      error => {
        callback && callback({ success: 0, error });
      }
    );
  };
};

export const fetchThisCommunityCategoryDetails = (
  session,
  cateId,
  callback
) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(communitycategoryid=${cateId})`
  );

  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.communityCategory}?filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        callback({ success: 1, data: data.resource[0] });
      },
      error => {
        callback({ success: 0 });
      }
    );
  };
};

export const searchCommunityCategory = (session, keywords, callback) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(categoryname CONTAINS ${keywords})`
  );
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.communityCategory}?filter=(${filter})&order=updatedon%20DESC`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({ type: FETCH_COMMUNITYCATEGORY, payload: data.resource });
        callback({ success: 1 });
      },
      error => {}
    );
  };
};

export const fetchCommunityDetails = (session, categoryid, type, callback) => {
  const fetchFilter = encodeURI(
    `((communitycategoryidfk=${categoryid})AND(eventid=${session.eventid}))`
  );
  const related = `appuser_by_postedby,appuser_by_communitypostcomment,appuser_by_communitypostlike,communitypostlike_by_communitypostidfk,communitypost_extra_by_communitypostidfk,communityfollower_by_communitypostid&appuser_by_postedby.fields=${FIELDS.appuser.relatedInfo}&appuser_by_communitypostcomment.fields=${FIELDS.appuser.relatedInfo}&appuser_by_communitypostlike.fields=${FIELDS.appuser.relatedInfo}&communitypostlike_by_communitypostidfk.fields=${FIELDS.communityPostLike.minInfo}&communitypost_extra_by_communitypostidfk.fields=${FIELDS.communityPostExtra.mediumInfo}&communityfollower_by_communitypostid.fields=${FIELDS.communityFollower.minInfo}`;

  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.communitypost}?include_count=true&related=${related}&filter=${fetchFilter}&order=${FETCH_ORDERS.communitypost}`;

  if (type == 'comment' || type == 'group') {
    let offSetQuery = `&limit=20&offset=0`;
    url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.communitypostcomment}?include_count=true&related=appuser_by_commentedby&appuser_by_commentedby.fields=${FIELDS.appuser.relatedInfo}&filter=${fetchFilter}&order=${FETCH_ORDERS.communitypostcomment}${offSetQuery}`;
  }

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      res => {
        if (type == 'comment' || type == 'group') {
          dispatch({ type: FETCH_FORUM_DETAILS, payload: res });
          callback({ success: 1, data: res });
        } else {
          let resData = res.resource;

          let promiseArr = [];
          !_.isEmpty(resData) &&
            _.map(res.resource, (post, postIndex) => {
              if (!_.isEmpty(post?.communitypost_extra_by_communitypostidfk)) {
                let extra = post?.communitypost_extra_by_communitypostidfk;

                if (!_.isNil(extra?.exhibitoridfk)) {
                  promiseArr.push(
                    new Promise((resolve, reject) => {
                      dispatch(
                        fetchDetailsByExhibitorId(
                          session,
                          extra?.exhibitoridfk,
                          exhRes => {
                            resData[postIndex] = {
                              ..._.cloneDeep(post),
                              exhibitordetails: exhRes
                            };
                            resolve();
                          }
                        )
                      );
                    })
                  );
                }
                if (!_.isNil(extra?.sponsorid)) {
                  promiseArr.push(
                    new Promise((resolve, reject) => {
                      dispatch(
                        fetchDetailsBySponsorId(
                          session,
                          extra?.sponsorid,
                          sponRes => {
                            resData[postIndex] = {
                              ..._.cloneDeep(post),
                              sponsorDetails: sponRes
                            };
                            resolve();
                          }
                        )
                      );
                    })
                  );
                }
              }
            });

          Promise.all(promiseArr).then(() => {
            dispatch({
              type: FETCH_FORUM_DETAILS,
              payload: { count: res.meta.count, data: resData }
            });
            callback({ success: 1, data: resData });
          });
        }
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const clearCommunityDetails = () => {
  return dispatch => {
    dispatch({ type: FETCH_FORUM_DETAILS, payload: {} });
  };
};

export const setForumDetails = category => {
  let values = !_.isEmpty(category)
    ? {
        viewDetails: true,
        type: category.type,
        catname: category.categoryname,
        categoryid: category.communitycategoryid,
        postadminonly: !category?.enableuserposting,
        details: category
      }
    : {};

  // ----- Managing selected community new post count at localstorage
  if (!_.isEmpty(category)) {
    let prevCommunityCount = _.cloneDeep(
      loadFromLocalDB(PORTAL_LOCALSTORAGE_ACCESS_KEY.community)
    );

    _.map(prevCommunityCount, comm => {
      if (comm?.id == category.communitycategoryid)
        comm.count = _.includes(
          ALLOWED_COMMUNITY_CATEGORIES.post,
          category.type
        )
          ? category.postcount
          : category.commentcount;
    });

    setInLocalDB({
      key: PORTAL_LOCALSTORAGE_ACCESS_KEY.community,
      value: prevCommunityCount
    });
  }

  return dispatch => {
    dispatch({
      type: SET_FORUM_DETAILS,
      payload: values
    });
  };
};

export const showOnlyCommunityDetails = bool => {
  return dispatch => {
    dispatch({ type: SHOW_ONLY_COMMUNITY_DETAILS, payload: bool });
  };
};

export const clearPostComment = () => {
  return dispatch => {
    dispatch({ type: FETCH_POST_COMMENT, payload: {} });
  };
};

export const setPostComment = (viewDetails = false, communitypostid = '') => {
  return dispatch => {
    dispatch({
      type: SET_POST_COMMENT,
      payload: {
        viewDetails: viewDetails,
        communitypostid: communitypostid
      }
    });
  };
};

export const fetchComments = (session, communitypostid, callback) => {
  let filter = encodeURI(
    `(communitypostidfk=${communitypostid})AND(eventid=${session.eventid})`
  );
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.communitypostcomment}?include_count=true&related=appuser_by_commentedby&appuser_by_commentedby.fields=${FIELDS.appuser.relatedInfo}&filter=(${filter})&order=createdon`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        let commentedUsers = [];

        let local_data = _.cloneDeep(data);

        const response = shuffleComments(
          'communitypostcommentid',
          local_data.resource
        );
        local_data.resource = response;

        _.map(local_data.resource, (postGroupItem, postGroupItemIndex) => {
          commentedUsers.push(postGroupItem.appuser_by_commentedby);
        });

        dispatch({ type: FETCH_POST_COMMENT, payload: local_data });
        callback({
          success: 1,
          resource: local_data.resource,
          usercommented: commentedUsers
        });
      },
      error => {}
    );
  };
};

export const fetchPostLike = (session, communitypostid, callback) => {
  let filter = encodeURI(
    `(communitypostidfk=${communitypostid})AND(eventid=${session.eventid})`
  );
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.communityPostLike}?filter=(${filter})&order=updatedon%20DESC`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({ type: FETCH_POST_LIKE, payload: data.resource });
        callback({ success: 1 });
      },
      error => {}
    );
  };
};

export const clearPostLike = () => {
  return dispatch => {
    dispatch({ type: FETCH_POST_LIKE, payload: {} });
  };
};

export const openModalPostComment = bool => {
  return dispatch => {
    dispatch({ type: SHOW_POST_COMMENT_MODAL, payload: bool });
  };
};

export const setCategoryPost = item => {
  return dispatch => {
    dispatch({ type: SET_POST, payload: item });
  };
};

/**
 * @param values JSON | {action: 'create | update | delete', data: JSON | communitypostlikeid }
 */
export const communityPostLikeDislike = (session, values, callback) => {
  let tableUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.communityPostLike}`;

  const actionType = values.action;

  if (actionType === 'delete') {
    let deleteFilter = encodeURI(
      `((communitypostidfk=${values.data})AND(likedby=${session.userid})AND(eventid=${session.eventid}))`
    );
    tableUrl = `${tableUrl}?filter=${deleteFilter}`;

    return dispatch => {
      deleteRequest(
        tableUrl,
        session,
        dispatch,
        delres => {
          callback({ success: 1 });
        },
        error => {
          callback({ success: 0, message: error });
        }
      );
    };
  } else if (actionType === 'update') {
    if (_.isEmpty(values?.data)) {
      callback({ success: 0, message: 'Check payload.' });
      return dispatch => {};
    }

    let localBody = _.cloneDeep(values.data);
    let pk = values.data?.communitypostlikeid;
    delete localBody.communitypostlikeid;

    return dispatch => {
      patchRequest(
        `${tableUrl}/${pk}`,
        localBody,
        session,
        dispatch,
        response => {
          callback({ success: 1 });
        },
        error => {
          callback({ success: 0, message: error });
        }
      );
    };
  } else {
    return dispatch => {
      postRequest(
        tableUrl,
        { resource: [{ ...values.data }] },
        session,
        dispatch,
        response => {
          callback({ success: 1 });
        },
        error => {
          callback({ success: 0, message: error });
        }
      );
    };
  }
};

export function sendChat(session, values, callback) {
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.communitypostcomment}`;
  let body = { resource: values };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export const openCreatePostModal = (state = false, editItem = null) => {
  return dispatch => {
    dispatch({
      type: CREATE_POST_MODAL,
      payload: {
        state,
        editItem
      }
    });
  };
};

/*
  values structure

  {
    type: '', string | category type
    categoryid: null, int | category id
    payload: {}, object | post payload
    isUpdate: false, bool | if action is to update post
    postId: null, int | post id if action is to update
  }
*/
export const createCommunityPost = (
  session,
  extra = {
    type: '',
    categoryid: null,
    payload: {},
    isUpdate: false,
    postId: null
  },
  callback
) => {
  if (
    _.isEmpty(extra?.payload) ||
    _.isNil(extra?.categoryid) ||
    _.isEmpty(extra?.type) ||
    (extra?.isUpdate && _.isNil(extra?.postId))
  )
    return dispatch => {};

  let postUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.communitypost}`;
  let postBody = {};
  if (extra?.isUpdate) postBody = extra?.payload;
  else postBody = { resource: [{ ...extra?.payload }] };

  return dispatch => {
    if (extra?.isUpdate) {
      patchRequest(
        `${postUrl}/${extra?.postId}`,
        postBody,
        session,
        dispatch,
        res => {
          dispatch(
            fetchCommunityDetails(
              session,
              extra?.categoryid,
              extra?.type,
              fetchRes => {
                showSuccess(LocalStrings.dynamic.kUpdatedSuccessfully);
                callback({ success: 1 });
              }
            )
          );
        },
        error => {
          callback({ success: 0, message: error });
        }
      );
    } else
      postRequest(
        postUrl,
        postBody,
        session,
        dispatch,
        postCreateRes => {
          dispatch(
            fetchCommunityDetails(
              session,
              extra?.categoryid,
              extra?.type,
              fetchRes => {
                callback({ success: 1 });
              }
            )
          );
        },
        error => {
          callback({ success: 0, message: error });
        }
      );
  };
};

export const fetchNewMessage = (
  session,
  categoryid,
  lastTimestamp,
  callback
) => {
  // let filter = encodeURI(
  //   `(communitycategoryidfk=${categoryid})AND(unixtimestamp > ${lastTimestamp})AND(eventid=${session.eventid})`
  // );
  let filter = encodeURI(
    `(communitycategoryidfk=${categoryid})AND(eventid=${session.eventid})`
  );
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.communitypostcomment}?related=appuser_by_commentedby&appuser_by_commentedby.fields=${FIELDS.appuser.relatedInfo}&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({ type: FETCH_NEW_MESSAGE, payload: data.resource });
        callback({ success: 1, data: data.resource });
      },
      error => {}
    );
  };
};

export const fetchOlderMessage = (session, categoryid, offset, callback) => {
  let filter = encodeURI(
    `(communitycategoryidfk=${categoryid})AND(eventid=${session.eventid})`
  );

  let offSetQuery = `&limit=20&offset=${offset}`;
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.communitypostcomment}?related=appuser_by_commentedby&appuser_by_commentedby.fields=${FIELDS.appuser.relatedInfo}&filter=(${filter})&order=unixtimestamp%20DESC${offSetQuery}`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({ type: FETCH_OLD_MESSAGE, payload: data.resource });
        callback({ success: 1 });
      },
      error => {}
    );
  };
};

export const fetchCommunityMemberDetails = (session, cateId, callback) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(communitycategoryidfk=${cateId})AND(useridfk=${session.userid})`
  );
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.communityMember}?related=appuser_by_useridfk&appuser_by_useridfk.fields=${FIELDS.appuser.relatedInfo}&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      response => {
        // 'requested','accepted','removed','left','rejected' defined statuses
        if (response.metadata?.isuseradmin == 1) {
          callback({ success: 1, allow: 2, data: response.resource[0] });
        } else if (
          _.isEmpty(response.resource) ||
          response.resource[0]?.status == 'left' ||
          response.resource[0]?.status == 'rejected' ||
          response.resource[0]?.status == 'removed'
        ) {
          callback({ success: 1, allow: 0, data: response.resource[0] });
        } else {
          if (response.resource[0]?.status == 'accepted') {
            callback({ success: 1, allow: 2, data: response.resource[0] });
          } else {
            callback({ success: 1, allow: 1, data: response.resource[0] });
          }
        }
      },
      error => {
        callback({ success: 0, error });
      }
    );
  };
};

export const requestCommunityMembership = (session, value, callback) => {
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.communityMember}`;
  let body = { resource: [value] };

  if (value.id) {
    let localBody = _.cloneDeep(value);
    delete localBody.id;
    delete localBody.createdon;

    return dispatch => {
      patchRequest(
        `${url}/${value.id}`,
        localBody,
        session,
        dispatch,
        response => {
          callback({ success: 1, data: response });
        },
        error => {
          callback({ success: 0, error });
        }
      );
    };
  } else {
    return dispatch => {
      postRequest(
        url,
        body,
        session,
        dispatch,
        response => {
          callback({ success: 1 });
        },
        error => {
          callback({ success: 0, message: error });
        }
      );
    };
  }
};

export const cancelCommunityMembership = (session, value, callback) => {
  let updateUrl = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.communityMember}/${value.id}`;

  let local_body = _.cloneDeep(value);
  delete local_body.id;

  return dispatch => {
    patchRequest(
      updateUrl,
      local_body,
      session,
      dispatch,
      response => {
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0 });
      }
    );
  };
};

export const requestCommunityFollowUnfollow = (session, dataObj, callback) => {
  let url = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.communityScript.endpoint}`;

  return dispatch => {
    postRequest(
      url,
      dataObj,
      session,
      dispatch,
      res => {
        if (res.resource?.success == 1) {
          callback({
            success: true
          });
        }
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const fetchCommunityFollowUnfollowStatus = (
  session,
  dataObj,
  callback
) => {
  let url = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.communityScript.endpoint}`;

  // depending upon dataObj will get both community and post
  return dispatch => {
    postRequest(
      url,
      dataObj,
      session,
      dispatch,
      res => {
        callback({
          success: true,
          data: res.resource?.isfollowed == '1' ? true : false
        });
      },
      error => {
        callback({ success: false, message: error });
      }
    );
  };
};

export const selectedCommunity = (session, values, callback) => {
  return dispatch => {
    dispatch(
      fetchCommunityMemberList(session, values.communitycategoryid, res => {
        if (res.success) {
          let obj = {
            details: values,
            members: res.data,
            memberCount: res.count
          };
          dispatch({ type: SELECTED_COMMUNITY_DETAILS, payload: obj });
          callback({
            success: true,
            message: 'Successfully fetched member list'
          });
        } else {
          callback(res);
        }
      })
    );
  };
};

export const fetchCommunityMemberList = (session, cateId, callback) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(communitycategoryidfk=${cateId})AND((status=accepted)OR(status=requested))`
  );
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.communityMember}?include_count=true&related=appuser_by_useridfk&appuser_by_useridfk.fields=${FIELDS.appuser.relatedInfo}&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      res => {
        callback({ success: true, data: res.resource });
      },
      error => {
        callback({ success: false, message: error });
      }
    );
  };
};

export const deleteCommunityPost = (session, values, callback) => {
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.communitypost}/${values.postid}`;

  return dispatch => {
    deleteRequest(
      url,
      session,
      dispatch,
      res => {
        dispatch(
          fetchCommunityDetails(
            session,
            values.categoryid,
            values.type,
            fetchRes => {
              callback({ success: 1 });
            }
          )
        );
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const deleteCommunityPostComment = (
  session,
  postCommentId,
  callback
) => {
  let url = `${session.instance_url}${TABLE_URI_ADDON}/${TABLES.communitypostcomment}/${postCommentId}`;

  return dispatch => {
    deleteRequest(
      url,
      session,
      dispatch,
      res => {
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const unreadCommunityMessageCount = () => {
  let local_newPostCount = _.includes(
    ALLOWED_COMMUNITY_CATEGORIES.post,
    item.type
  )
    ? item?.postcount
    : item.commentcount;
};

export const fetchExportApplicantsCSVData = (
  session,
  postId = null,
  callback
) => {
  if (!postId) return dispatch => {};

  let postURL = `${session.instance_url}${SCRIPT_URI_ADDON}/${SCRIPTS.userQR.exportApplicants.endpoint}`;
  let postBody = _.cloneDeep(SCRIPTS.userQR.exportApplicants.payload);
  postBody.eventid = session.eventid;
  postBody.userid = session.userid;
  postBody.cpostid = postId;

  return dispatch => {
    postRequest(
      postURL,
      postBody,
      session,
      dispatch,
      res => {
        callback({ success: 1, data: res?.resource, error: null });
      },
      error => {
        callback({ success: 0, data: null, error });
      }
    );
  };
};
